import { Component,OnInit,ChangeDetectorRef,HostListener } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { NgNavigatorShareService } from 'ng-navigator-share';


import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/common.service';
import Swal from 'sweetalert2'

declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-mychat',
  templateUrl: './mychat.component.html',
  styleUrls: ['./style.css']
})
 
export class MychatComponent implements OnInit {
  currentUser:any;
  sendreqestmodel:any={};
  currentUserID:any;
  api_bases:any;
  Newgroupmodel: any = {}; 
  group_dt_model:Array<Object>;
  group_name:any;
  group_members_model:Array<Object>;
  group_msg_model:any;
  date_array_model:any;
  group_profile_log_model:Array<Object>;
  group_det:Array<Object>;
  userdropdownList:any;
  userdropdownSettings:any={};
  interval: any;
  group_bases:any;
  imageuploadmsg:any;
  slideIndex:any;
  grouplink:any;
  windowHeight:any;
  showShortMenu = false;
  playingMp3Id: any = null;
  mp3Progress: any = {};
  mp3Duration: any = {};
  mp3Current: any = {};
  mp3WaveBars: number[] = [35, 62, 48, 88, 42, 75, 55, 92, 38, 70, 50, 85, 45, 68, 58, 90, 40, 72, 52, 80, 44, 66, 56, 86, 36, 74, 48, 82, 54, 78, 42, 88, 46, 70, 60];
  playingMp4Id: any = null;
  mp4Current: any = {};
  mp4Duration: any = {};
  editingMsg = false;
  replyingMsg = false;
  replyPreview = '';
  replyUserName = '';
  showAttachMenu = false;
  uploadingMedia = false;
  uploadPreviewUrl: string = '';
  uploadFileName: string = '';
  uploadMediaType: string = '';
  captionMsgId: any = null;
  highlightedReplyMsgId: any = null;
  private replyHighlightTimer: any = null;
  msgHasMoreOlder = false;
  msgLoadingOlder = false;
  msgOldestId: any = 0;
  msgNewestId: any = 0;

 private ngNavigatorShareService: NgNavigatorShareService;

  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http,ngNavigatorShareService: NgNavigatorShareService,private cdr: ChangeDetectorRef,private sanitizer: DomSanitizer) { 
      document.body.className="theme-red";
      this.ngNavigatorShareService = ngNavigatorShareService;

  }

  ngOnInit() {
    this.api_bases = AppSettings.IMAGE_BASE_CHAT;
    this.group_bases = AppSettings.IMAGE_BASE;
    this.slideIndex = 1; 
    this.Newgroupmodel.channelgroup=2;
    this.Newgroupmodel.privatepublic=2;
    this.showSlides(this.slideIndex);
    this.group_dt_model=[];
    this.userdropdownList=[];
    this.Newgroupmodel.groupimagename = '';
    this.Newgroupmodel.search_group_name = '';
   // this.Newgroupmodel.groupcode='';
   this.imageuploadmsg=0;
    this.group_name=0;
    this.group_msg_model=[];
    this.sendreqestmodel.Isloading=false;
    this.date_array_model=[];
    this.group_members_model=[];
    this.Newgroupmodel.userselectedItems=[]; 
    this.loginService.localStorageData();
    this.loginService.viewsActivate();
    this.loginService.viewsUploadoption();
    this.Newgroupmodel.currentUserID=localStorage.getItem('currentUserID');
    this.Newgroupmodel.currentUser=localStorage.getItem('currentUser');
    this.Newgroupmodel.userselectedItems=[{'Id':this.Newgroupmodel.currentUserID,'username':this.Newgroupmodel.currentUser}];
    this.userdropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

     //code added for auto height
     var rehigh=107;
     this.windowHeight = ($(window).innerHeight()-rehigh);
     console.log('height:'+ $(window).innerHeight());
     console.log('addedheight:'+this.windowHeight);
        $('#messages').css('height', this.windowHeight);
        $("#messages").stop().animate({ scrollTop: $("#messages")[0].scrollHeight}, 1000);
    //code ends here

    
    //this.getparamas = this.route.params.subscribe(params => {
     //this.Newgroupmodel.groupcode = params['id']; // (+) converts string 'id' to a number
    //}); 
    //console.log(this.Newgroupmodel.groupcode);
    this.getgrouplists();
    this.getuserlists();
    this.Newgroupmodel.g_id=''; 
    
    this.interval = setInterval(() => { 
      this.getgrouplists();
    }, 25000);
this.getwebsitelist();
    // this.selectedItems = [
    //   { Id: 3, username: 'Pune' },
    //   { Id: 4, username: 'Navsari' }
    // ];
    
  }

    toggleShortMenu() {
    this.showShortMenu = !this.showShortMenu;
  }

    clearoldval()
{
  this.Newgroupmodel.userselectedItems=[];
  this.Newgroupmodel.groupname='';
  this.Newgroupmodel.groupimagename='';
  this.Newgroupmodel.privatepublic=2;
  this.Newgroupmodel.channelgroup=2;  
  this.Newgroupmodel.resale_status=0;
  this.Newgroupmodel.resale_price_input='';
  this.Newgroupmodel.userselectedItems.push({'Id':this.Newgroupmodel.currentUserID,'username':this.Newgroupmodel.currentUser});
  this.showShortMenu = !this.showShortMenu;
}

  share() {
  this.grouplink = AppSettings.chatshare+this.Newgroupmodel.groupcode;
  
    this.ngNavigatorShareService.share({
      title: 'My Awesome app',
      text: 'Click to Join this group',
      url: this.grouplink
    }).then( (response) => {
      console.log(response);
    })
    .catch( (error) => {
      console.log(error);
    });
  }
  

  ngOnDestroy() {
  if (this.interval) {
    clearInterval(this.interval);
  }
}

  refreshData(){
  if (this.interval) {
    clearInterval(this.interval);
    this.interval = null;
  }
  if(this.router.url!="/mychat"){
    this.Newgroupmodel.g_id='';
  }
  else if(this.Newgroupmodel.g_id!='' && this.router.url=="/mychat"){
   this.interval = setInterval(() => {
   if(this.router.url!="/mychat" || this.Newgroupmodel.g_id==''){
    this.Newgroupmodel.g_id='';
      clearInterval(this.interval);
    } else {
      this.generateMessageArea(this.Newgroupmodel.g_id, false, 'incremental');
    }
    }, 35000);
  }
    
  }
  getuserlists(){
    // this.CommonService.getdata(AppSettings.getchatuserslist)
    this.CommonService.insertdata(AppSettings.getchatuserslist,{'currentUsername':this.Newgroupmodel.currentUser})
    .subscribe(det =>{
      
        if(det.result!=""){ this.userdropdownList=det.result;}
        
    });
  }
  getgrouplists(){    

    // this.CommonService.getdata(AppSettings.getgroups)
    this.CommonService.insertdata(AppSettings.getmygroups,this.Newgroupmodel)
    .subscribe(det =>{      
        if(det.result!=""){ this.group_det=det.result;}
    });
  }

  generateMessageArea1(id,p_p,g_code){
    if(p_p==4){
    }else {
      this.resetMsgPaging();
      this.generateMessageArea(id, true, 'initial');
      this.refreshData();
    }
  }
  groupsearch(){
    this.group_det=[];
     this.CommonService.insertdata(AppSettings.getmygroups,this.Newgroupmodel)
    .subscribe(det =>{      
        if(det.result!=""){ this.group_det=det.result;}
    });
  }

  hideshow(){
  this.Newgroupmodel.g_id = '';
  $('.mainmenu_navbar').removeClass('dhana');
     $('.chat-list').removeClass('d-none');
    $('.message-area').removeClass('d-flex');
    $('.chat-list').addClass('d-flex');
    $('.message-area').addClass('d-none');
    
  } 
  generateMessageArea(g_id, forceScroll: boolean = true, loadMode: string = 'initial'){
    const mode = loadMode || 'initial';
    if (mode === 'older' && this.msgLoadingOlder) {
      return;
    }
    if (mode === 'initial') {
      if (String(this.Newgroupmodel.g_id) !== String(g_id)) {
        this.playingMp3Id = null;
        this.playingMp4Id = null;
        this.group_msg_model = <any>{};
        this.date_array_model = [];
      }
      this.resetMsgPaging();
      if($(window).width() > 450){
        $('.mainmenu_navbar').removeClass('dhana');
        $('.chat-list').removeClass('d-none');
        $('.message-area').removeClass('d-flex');
        $('.chat-list').addClass('d-flex');
        $('.message-area').addClass('d-none');
      } else {
        $('.mainmenu_navbar').addClass('dhana');
        $('.chat-list').removeClass('d-flex');
        $('.message-area').removeClass('d-none');
        $('.chat-list').addClass('d-none');
        $('.message-area').addClass('d-flex');
      }
    }

    this.Newgroupmodel.g_id=g_id;
    this.Newgroupmodel.msg_load_mode = mode;
    this.Newgroupmodel.msg_limit = 50;
    this.Newgroupmodel.before_id = this.msgOldestId || 0;
    this.Newgroupmodel.after_id = this.msgNewestId || 0;
    this.Newgroupmodel.loaded_ids = (mode === 'incremental') ? this.collectLoadedMsgIds() : [];
    if (mode === 'older') {
      this.msgLoadingOlder = true;
    }
    const messagesEl = document.getElementById('messages') as HTMLElement;
    const prevScrollHeight = messagesEl ? messagesEl.scrollHeight : 0;
    const prevScrollTop = messagesEl ? messagesEl.scrollTop : 0;

    this.CommonService.insertdata(AppSettings.mychatgroup,this.Newgroupmodel)
        .subscribe(resultdata =>{   
          this.group_name=1;
          if(resultdata.check_user==0){
            this.msgLoadingOlder = false;
          } else{
            if (mode === 'initial') {
              const shouldScroll = forceScroll || this.isMessagesNearBottom();
              this.group_dt_model = resultdata.group_details[0];
              this.sendreqestmodel.groupId=resultdata.group_details[0].id;
              this.Newgroupmodel.groupname = resultdata.group_details[0].group_name;
              this.Newgroupmodel.groupcode = resultdata.group_details[0].group_code;
              this.Newgroupmodel.privatepublic = resultdata.group_details[0].private_public;
              this.Newgroupmodel.groupimagename = resultdata.group_details[0].imagename;
              this.Newgroupmodel.created_by = resultdata.group_details[0].created_by;
              this.Newgroupmodel.channelgroup = resultdata.group_details[0].channelgroup;
              this.Newgroupmodel.resale_status = resultdata.group_details[0].resale_status;
              this.Newgroupmodel.resale_price = resultdata.group_details[0].resale_price;
              this.applyGroupMessages(resultdata.group_msg, resultdata.date_array);
              this.applyPagingMeta(resultdata, 'initial');
              this.Newgroupmodel.userselectedItems=resultdata.select_group_members;
              this.group_members_model=resultdata.group_members;
              this.group_profile_log_model=resultdata.group_profile_details; 
              $('.message-area').addClass('d-sm-flex');
              if (shouldScroll) {
                this.scrollMessagesToBottom();
              }
            } else if (mode === 'older') {
              this.prependOlderMessages(resultdata.group_msg, resultdata.date_array);
              this.applyPagingMeta(resultdata, 'older');
              setTimeout(() => {
                const el = document.getElementById('messages') as HTMLElement;
                if (el) {
                  el.scrollTop = el.scrollHeight - prevScrollHeight + prevScrollTop;
                }
              }, 0);
            } else {
              this.applyIncrementalPayload(resultdata);
              if (forceScroll || this.isMessagesNearBottom()) {
                this.scrollMessagesToBottom();
              }
            }
          }
          this.msgLoadingOlder = false;
        }, () => {
          this.msgLoadingOlder = false;
        });
  }
  
  isMessagesNearBottom(threshold: number = 140): boolean {
    const el = document.getElementById('messages') as HTMLElement;
    if (!el) { return true; }
    return (el.scrollHeight - el.scrollTop - el.clientHeight) <= threshold;
  }

  trackByMsgId(index: number, data: any) {
    return data && data.id != null ? data.id : index;
  }

  trackByDate(index: number, datedata: any) {
    return datedata != null ? datedata : index;
  }

  isMediaPlaying(): boolean {
    if (this.playingMp4Id != null) {
      return true;
    }
    if (this.playingMp3Id != null) {
      return true;
    }
    return false;
  }

  private hasExistingMessages(): boolean {
    if (!this.group_msg_model) { return false; }
    return Object.keys(this.group_msg_model).some((key) => {
      const list = this.group_msg_model[key];
      return list && list.length > 0;
    });
  }

  applyGroupMessages(newMsgModel: any, newDateArray: any) {
    if (!this.isMediaPlaying() || !this.hasExistingMessages()) {
      this.group_msg_model = newMsgModel || {};
      this.date_array_model = newDateArray || [];
      return;
    }
    this.mergeGroupMessages(newMsgModel || {}, newDateArray || []);
  }

  private mergeGroupMessages(incoming: any, incomingDates: any[]) {
    const existingIds = new Set<string>();
    Object.keys(this.group_msg_model || {}).forEach((dateKey) => {
      (this.group_msg_model[dateKey] || []).forEach((m: any) => {
        if (m && m.id != null) {
          existingIds.add(String(m.id));
        }
      });
    });

    const playingId = this.playingMp4Id != null
      ? String(this.playingMp4Id)
      : (this.playingMp3Id != null ? String(this.playingMp3Id) : null);

    Object.keys(incoming).forEach((dateKey) => {
      const incomingList = incoming[dateKey] || [];
      if (!this.group_msg_model[dateKey]) {
        const onlyNew = incomingList.filter((m: any) => m && !existingIds.has(String(m.id)));
        if (onlyNew.length) {
          this.group_msg_model[dateKey] = onlyNew;
          onlyNew.forEach((m: any) => existingIds.add(String(m.id)));
          if ((this.date_array_model || []).indexOf(dateKey) === -1) {
            this.date_array_model = [...(this.date_array_model || []), dateKey];
          }
        }
        return;
      }

      const existingList = this.group_msg_model[dateKey];
      incomingList.forEach((m: any) => {
        if (!m || m.id == null) { return; }
        const id = String(m.id);
        if (!existingIds.has(id)) {
          existingList.push(m);
          existingIds.add(id);
          return;
        }
        if (playingId && id === playingId) {
          return;
        }
        const idx = existingList.findIndex((x: any) => String(x.id) === id);
        if (idx >= 0) {
          const target = existingList[idx];
          if (target.message !== m.message) { target.message = m.message; }
          if (target.replyid !== m.replyid) { target.replyid = m.replyid; }
          if (target.reply_user_name !== m.reply_user_name) { target.reply_user_name = m.reply_user_name; }
          if (target.reply_message !== m.reply_message) { target.reply_message = m.reply_message; }
        }
      });
    });

    (incomingDates || []).forEach((dateKey) => {
      if ((this.date_array_model || []).indexOf(dateKey) === -1) {
        this.date_array_model = [...(this.date_array_model || []), dateKey];
      }
    });
  }

  private resetMsgPaging() {
    this.msgOldestId = 0;
    this.msgNewestId = 0;
    this.msgHasMoreOlder = false;
    this.msgLoadingOlder = false;
  }

  private collectLoadedMsgIds() {
    const ids = [];
    Object.keys(this.group_msg_model || {}).forEach((dateKey) => {
      (this.group_msg_model[dateKey] || []).forEach((m: any) => {
        if (m && m.id != null) {
          ids.push(m.id);
        }
      });
    });
    return ids;
  }

  private applyPagingMeta(resultdata: any, mode: string) {
    if (mode === 'initial') {
      this.msgOldestId = resultdata.oldest_id || 0;
      this.msgNewestId = resultdata.newest_id || 0;
      this.msgHasMoreOlder = resultdata.has_more_older == 1 || resultdata.has_more_older === '1';
      return;
    }
    if (mode === 'older') {
      if (resultdata.oldest_id) {
        this.msgOldestId = resultdata.oldest_id;
      }
      this.msgHasMoreOlder = resultdata.has_more_older == 1 || resultdata.has_more_older === '1';
    }
  }

  private applyIncrementalPayload(resultdata: any) {
    if (resultdata.group_msg && Object.keys(resultdata.group_msg).length) {
      this.mergeGroupMessages(resultdata.group_msg, resultdata.date_array || []);
    }
    if (resultdata.newest_id && Number(resultdata.newest_id) > Number(this.msgNewestId || 0)) {
      this.msgNewestId = resultdata.newest_id;
    }
    this.applyUpdatedMessages(resultdata.updated_messages || []);
    this.applyDeletedMessages(resultdata.deleted_ids || []);
    this.group_msg_model = Object.assign({}, this.group_msg_model || {}) as any;
  }

  private applyUpdatedMessages(rows: any[]) {
    if (!rows || !rows.length) { return; }
    const playingId = this.playingMp4Id != null
      ? String(this.playingMp4Id)
      : (this.playingMp3Id != null ? String(this.playingMp3Id) : null);
    rows.forEach((m: any) => {
      if (!m || m.id == null) { return; }
      if (playingId && String(m.id) === playingId) { return; }
      const target = this.findMsgById(m.id);
      if (!target) { return; }
      if (target.message !== m.message) { target.message = m.message; }
      if (target.replyid !== m.replyid) { target.replyid = m.replyid; }
      if (target.reply_user_name !== m.reply_user_name) { target.reply_user_name = m.reply_user_name; }
      if (target.reply_message !== m.reply_message) { target.reply_message = m.reply_message; }
      if (target.chatimage !== m.chatimage) { target.chatimage = m.chatimage; }
    });
  }

  private applyDeletedMessages(ids: any[]) {
    if (!ids || !ids.length) { return; }
    const remove = {};
    ids.forEach((id) => { remove[String(id)] = true; });
    Object.keys(this.group_msg_model || {}).forEach((dateKey) => {
      this.group_msg_model[dateKey] = (this.group_msg_model[dateKey] || []).filter((m: any) => m && !remove[String(m.id)]);
      if (!this.group_msg_model[dateKey].length) {
        delete this.group_msg_model[dateKey];
        this.date_array_model = (this.date_array_model || []).filter((d) => d !== dateKey);
      }
    });
  }

  private prependOlderMessages(incoming: any, incomingDates: any[]) {
    if (!incoming) { return; }
    const dates = incomingDates || Object.keys(incoming);
    dates.forEach((dateKey) => {
      const list = incoming[dateKey] || [];
      if (!list.length) { return; }
      if (!this.group_msg_model[dateKey]) {
        this.group_msg_model[dateKey] = list.slice();
      } else {
        const existingIds = {};
        const curList: any[] = [].concat(this.group_msg_model[dateKey] || []);
        curList.forEach((m: any) => {
          if (m && m.id != null) { existingIds[String(m.id)] = true; }
        });
        const onlyOlder = list.filter((m: any) => m && !existingIds[String(m.id)]);
        this.group_msg_model[dateKey] = onlyOlder.concat(curList);
      }
    });
    const newDates = (dates || []).filter((d) => (this.date_array_model || []).indexOf(d) === -1);
    this.date_array_model = newDates.concat(this.date_array_model || []);
    this.group_msg_model = Object.assign({}, this.group_msg_model) as any;
  }

  onMessagesScroll(event: any) {
    const el = event && event.target;
    if (!el || this.msgLoadingOlder || !this.msgHasMoreOlder) {
      return;
    }
    if (el.scrollTop <= 80) {
      this.loadOlderMessages();
    }
  }

  loadOlderMessages() {
    if (!this.Newgroupmodel.g_id || !this.msgOldestId || this.msgLoadingOlder || !this.msgHasMoreOlder) {
      return;
    }
    this.generateMessageArea(this.Newgroupmodel.g_id, false, 'older');
  }

  scrollMessagesToBottom(retries: number = 3) {
    try {
      this.cdr.detectChanges();
    } catch (e) {}
    setTimeout(() => {
      const el = document.getElementById('messages') as HTMLElement;
      if (!el) { return; }
      el.scrollTop = el.scrollHeight;
      if (retries > 0) {
        setTimeout(() => this.scrollMessagesToBottom(retries - 1), 150);
      }
    }, 50);
  }

  updategroup()
  {
    this.CommonService.insertdata(AppSettings.updategroup,this.Newgroupmodel)
    .subscribe(package_det =>{     
      this.generateMessageArea(this.Newgroupmodel.g_id, true, 'incremental');
        this.getgrouplists();
        swal('','Group Updated Successfully','success');  
        
    });
  }

  deletegroup()
  {
    this.CommonService.insertdata(AppSettings.deletegroup,this.Newgroupmodel)
    .subscribe(package_det =>{    
    this.group_name=0;
    this.Newgroupmodel.g_id=''; 
    this.getgrouplists();
    this.ngOnInit();
      // this.router.navigate(['./chat']); 
        swal('','Group Deleted Successfully','success');  
        
    });
  }

  exitgroup()
  {
    this.CommonService.insertdata(AppSettings.exitgroup,this.Newgroupmodel)
    .subscribe(package_det =>{    
    this.group_name=0;
    this.Newgroupmodel.g_id=''; 
    this.getgrouplists();
    this.ngOnInit();
      // this.router.navigate(['./chat']); 
        swal('','Exit Group Successfully','success');  
        
    });
  }

  onGroupNameInput(event: any)
  {
    const cleaned = (event.target.value || '').replace(/[^\p{L}\p{M}\p{N} ]/gu, '');
    this.Newgroupmodel.groupname = cleaned;
    event.target.value = cleaned;
  }

  isValidGroupChannelName(name: string)
  {
    return /^[\p{L}\p{M}\p{N}]+(?: [\p{L}\p{M}\p{N}]+)*$/u.test(name || '');
  }

  addgroup()
  {
  this.Newgroupmodel.g_id='';
  const groupname = (this.Newgroupmodel.groupname || '').trim().replace(/\s+/g, ' ');
  this.Newgroupmodel.groupname = groupname;
  if(groupname==''){
    swal('','groupname is required','error');
    return;
  }
  if(!this.isValidGroupChannelName(groupname)){
    swal('','Special characters are not allowed. Use letters, numbers and spaces','error');
    return;
  }
  if(this.Newgroupmodel.privatepublic==4 || this.Newgroupmodel.privatepublic=='4'){
    this.CommonService.insertdata(AppSettings.checkgroupname,{'groupname':this.Newgroupmodel.groupname,'privatepublic':this.Newgroupmodel.privatepublic,'channelgroup':this.Newgroupmodel.channelgroup,'groupData':this.Newgroupmodel})
    .subscribe(chat_det =>{
      if(!chat_det || chat_det.status=='failure'){
        this.showCreateNameExistsError(chat_det);
        return;
      }
      if(chat_det.available_type=='resale'){
        this.confirmBuyResale(chat_det);
        return;
      }
      this.confirmCreatePublicPay(chat_det);
    }, () => {
      this.showCreateNameExistsError({ message: 'Unable to check name. Please try again.' });
    });
    return;
  }
  this.submitCreateGroup();
  }

  submitCreateGroup()
  {
    this.CommonService.insertdata(AppSettings.addgroup,this.Newgroupmodel)
    .subscribe(package_det =>{
      if(package_det.status=='failure'){
        this.showCreateGroupError(package_det);
        return;
      }
      $('#myModal').modal('hide');
      this.Newgroupmodel.groupname='';
      this.Newgroupmodel.groupimagename='';
      this.Newgroupmodel.privatepublic='';
      this.getgrouplists();
      if(package_det.purchase==1 || package_det.purchase=='1'){
        swal('','Purchased successfully','success');
      }else{
        swal('','Created Successfully','success');
      }
    });
  }

  confirmBuyResale(chat_det:any)
  {
    const typeLabel = chat_det.registration_type || 'channel/group';
    if(String(chat_det.created_by) === String(this.Newgroupmodel.currentUserID)){
      Swal.fire({
        type: 'error',
        title: 'You cannot buy your own ' + typeLabel
      });
      return;
    }
    Swal.fire({
      type: 'info',
      title: 'This public ' + typeLabel + ' is for resale',
      html: 'Resale price: ' + chat_det.resale_price + '<br>This amount will be deducted from your AI Money and paid to the owner.',
      showCancelButton: true,
      confirmButtonText: 'Buy',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if(result.value){
        this.submitCreateGroup();
      }
    });
  }

  confirmCreatePublicPay(chat_det:any)
  {
    const typeLabel = (chat_det && chat_det.registration_type) || ((this.Newgroupmodel.channelgroup==1 || this.Newgroupmodel.channelgroup=='1') ? 'channel' : 'group');
    const requiredCost = (chat_det && chat_det.required_cost !== undefined && chat_det.required_cost !== null) ? chat_det.required_cost : 0;
    Swal.fire({
      type: 'info',
      title: 'Confirm',
      html: 'Creating this public ' + typeLabel + ' requires <b>' + requiredCost + '</b> AI Money.<br>This amount will be deducted from your AI Money.',
      showCancelButton: true,
      confirmButtonText: 'Pay',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if(result.value){
        this.submitCreateGroup();
      }
    });
  }

  openResaleModal()
  {
    this.Newgroupmodel.resale_price_input = (this.Newgroupmodel.resale_price && this.Newgroupmodel.resale_price!=0) ? this.Newgroupmodel.resale_price : '';
    $('#resaleModal').modal('show');
  }

  putGroupForResale()
  {
    const price = parseFloat(this.Newgroupmodel.resale_price_input);
    if(!price || price <= 0){
      Swal.fire({ type: 'error', title: 'Enter a valid resale price' });
      return;
    }
    const alreadyListed = this.Newgroupmodel.resale_status==1 || this.Newgroupmodel.resale_status=='1';
    this.CommonService.insertdata(AppSettings.putgroupforresale, {
      g_id: this.Newgroupmodel.g_id,
      currentUserID: this.Newgroupmodel.currentUserID,
      resale_price: price
    }).subscribe(res => {
      if(res.status=='failure'){
        Swal.fire({ type: 'error', title: res.message || 'Unable to list for resale' });
        return;
      }
      $('#resaleModal').modal('hide');
      this.Newgroupmodel.resale_status = 1;
      this.Newgroupmodel.resale_price = price;
      swal('', alreadyListed ? 'Resale price updated' : 'Listed for resale','success');
    });
  }

  cancelGroupResale()
  {
    Swal.fire({
      type: 'warning',
      title: 'Cancel resale?',
      text: 'This channel/group will be removed from sale.',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if(!result.value){ return; }
      this.CommonService.insertdata(AppSettings.cancelgroupresale, {
        g_id: this.Newgroupmodel.g_id,
        currentUserID: this.Newgroupmodel.currentUserID
      }).subscribe(res => {
        if(res.status=='failure'){
          Swal.fire({ type: 'error', title: res.message || 'Unable to cancel resale' });
          return;
        }
        this.Newgroupmodel.resale_status = 0;
        this.Newgroupmodel.resale_price = 0;
        swal('','Resale cancelled','success');
      });
    });
  }

  canBuyListedGroup()
  {
    if(!this.Newgroupmodel || !this.Newgroupmodel.currentUserID){ return false; }
    if(!(this.Newgroupmodel.privatepublic==4 || this.Newgroupmodel.privatepublic=='4')){ return false; }
    if(!(this.Newgroupmodel.resale_status==1 || this.Newgroupmodel.resale_status=='1')){ return false; }
    if(String(this.Newgroupmodel.currentUserID) === String(this.Newgroupmodel.created_by)){ return false; }
    const uid = String(this.Newgroupmodel.currentUserID);
    const members:any = this.group_members_model || [];
    if(members && members.length){
      return members.some((m:any) => String(m.Id || m.user_id) === uid);
    }
    return true;
  }

  buyListedGroup(event?:any)
  {
    if(event){ event.stopPropagation(); }
    if(!this.canBuyListedGroup()){ return; }
    const typeLabel = (this.Newgroupmodel.channelgroup==1 || this.Newgroupmodel.channelgroup=='1') ? 'channel' : 'group';
    Swal.fire({
      type: 'info',
      title: 'Buy this public ' + typeLabel,
      html: 'Resale price: ' + this.Newgroupmodel.resale_price + '<br>This amount will be deducted from your AI Money and paid to the owner.',
      showCancelButton: true,
      confirmButtonText: 'Buy',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if(result.value){
        this.submitBuyListedGroup();
      }
    });
  }

  submitBuyListedGroup()
  {
    this.CommonService.insertdata(AppSettings.buygroupresale, {
      g_id: this.Newgroupmodel.g_id,
      currentUserID: this.Newgroupmodel.currentUserID
    }).subscribe(res => {
      if(res.status=='failure'){
        this.showCreateGroupError(res);
        return;
      }
      this.Newgroupmodel.resale_status = 0;
      this.Newgroupmodel.resale_price = 0;
      this.Newgroupmodel.created_by = this.Newgroupmodel.currentUserID;
      this.Newgroupmodel.admin_normal = 1;
      this.getgrouplists();
      this.generateMessageArea(this.Newgroupmodel.g_id, true, 'incremental');
      swal('','Purchased successfully','success');
    });
  }

  showCreateNameExistsError(chat_det:any)
  {
    Swal.fire({
      type: 'error',
      title: 'This name already exists',
      text: (chat_det && chat_det.message) || 'This name already exists'
    });
  }

  showCreateGroupError(package_det:any)
  {
    if(package_det && package_det.current_balance !== undefined && package_det.current_balance !== null){
      const typeLabel = package_det.registration_type || 'channel/group';
      Swal.fire({
        type: 'error',
        title: 'Insufficient balance',
        html: 'Current AI Money: ' + package_det.current_balance + '<br>Required: ' + package_det.required_cost
      });
      return;
    }
    swal('', (package_det && package_det.message) || 'Unable to create','error');
  }

  sendMessage(){
    if (this.editingMsg) {
      this.msgupdatefun();
      return;
    }
    if (this.replyingMsg) {
      this.replymsgupdatefun();
      return;
    }
    if(this.Newgroupmodel.groupmsgtxt!='' && this.Newgroupmodel.groupmsgtxt!=undefined || this.imageuploadmsg==1){
      this.CommonService.insertdata(AppSettings.sendmsg,this.Newgroupmodel)
      .subscribe(package_det =>{       
        
          this.Newgroupmodel.groupmsgtxt='';
          this.imageuploadmsg=0;
          this.clearUploadPending();
          this.resetComposeHeight();
          this.generateMessageArea(this.Newgroupmodel.g_id, true, 'incremental');
          // swal('','Message sent Successfully','success');  
          $('.message-area').addClass('d-sm-flex');
          $("#messages").stop().animate({ scrollTop: $("#messages")[0].scrollHeight}, 1000);

      }, () => {
        this.clearUploadPending();
      }); 
    }
    else {
      swal('','message is required','error');  
    }

    // this.CommonService.insertdata(AppSettings.sendmsg,this.Newgroupmodel)
    // .subscribe(package_det =>{       
      
    //     this.Newgroupmodel.groupmsgtxt='';
    //     this.generateMessageArea(this.Newgroupmodel.g_id);
    //     // swal('','Message sent Successfully','success');  
        
    // }); 
  }
   
  fileEvent($event) {
    const fileSelected: File = $event.target.files[0];
    this.Newgroupmodel.groupimagename =$event.target.files[0].name;
    this.CommonService.chatuploadFile(AppSettings.groupimage,fileSelected)
    .subscribe( (response) => {
       if(response.status=='success')
       {
         
        // this.Newgroupmodel.groupimagename = response.data;
        
       }
       
     })
  }
  plusSlides(n,m){
  this.showSlides(this.slideIndex += n);
  }

  currentSlide(n) {
  this.showSlides(this.slideIndex = n);
}

  showSlides(n) {
    var i;
    var slides = document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
    if (n > slides.length) {this.slideIndex = 1}    
    if (n < 1) {this.slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
       // slides[i].style.display = "none";  
        $('.pimage'+i).css('display','none'); 
    }
    for (i = 0; i < dots.length; i++) {
       // dots[i].className = dots[i].className.replace(" active", "");
    }
    //slides[this.slideIndex-1].style.display = "block"; 
    var all_val = this.slideIndex-1; 
    $('.pimage'+all_val).css('display','block');
    //dots[this.slideIndex-1].className += " active";
  }

  canDeleteGroupProfileImage() {
    return this.Newgroupmodel
      && (this.Newgroupmodel.admin_normal == 1 || this.Newgroupmodel.admin_normal == '1')
      && String(this.Newgroupmodel.currentUserID) === String(this.Newgroupmodel.created_by)
      && this.group_profile_log_model
      && this.group_profile_log_model.length > 1;
  }

  deleteGroupProfileImage(data: any, index?: number) {
    if (!this.canDeleteGroupProfileImage()) {
      swal('', 'At least one profile picture is required', 'warning');
      return;
    }
    if (!data || (!data.id && !data.image_name)) {
      return;
    }

    Swal.fire({
      title: '',
      text: 'Delete this profile picture?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (!result.value) { return; }

      const payload: any = {
        g_id: this.Newgroupmodel.g_id,
        image_id: data.id,
        image_name: data.image_name,
        currentUserID: this.Newgroupmodel.currentUserID
      };

      this.CommonService.insertdata(AppSettings.deletegroupprofileimage, payload)
        .subscribe((res: any) => {
          if (res && res.status === 'success') {
            this.group_profile_log_model = res.group_profile_details || [];
            if (res.imagename) {
              this.Newgroupmodel.groupimagename = res.imagename;
              if (this.group_dt_model) {
                (this.group_dt_model as any).imagename = res.imagename;
              }
            }
            setTimeout(() => {
              this.slideIndex = 1;
              this.showSlides(1);
            }, 50);
            swal('', res.message || 'Profile picture deleted', 'success');
          } else {
            swal('', (res && res.message) ? res.message : 'Unable to delete profile picture', 'error');
          }
        }, () => {
          swal('', 'Unable to delete profile picture', 'error');
        });
    });
  }

  msgfileEvent($event) {
    const fileSelected: File = $event.target.files[0];
    if (!fileSelected) { return; }
    this.showAttachMenu = false;
    this.startUploadPending(fileSelected);

    this.CommonService.chatuploadFile(AppSettings.msggroupimage,fileSelected)
    .subscribe( (response) => {
       if(response.status=='success')
       {
         this.Newgroupmodel.groupimagename = response.data;
         this.imageuploadmsg=1;
         if (this.editingMsg) {
           this.msgupdatefun();
         } else if (this.replyingMsg) {
           this.replymsgupdatefun();
         } else {
           this.Newgroupmodel.groupmsgtxt='';
           this.resetComposeHeight();
           this.sendMessage();
         }
       } else {
         this.clearUploadPending();
         swal('','Upload failed','error');
       }
       
     }, () => {
       this.clearUploadPending();
       swal('','Upload failed','error');
     })
  }
  startUploadPending(file: File) {
    this.clearUploadPending();
    this.uploadingMedia = true;
    this.uploadFileName = file.name || 'Uploading...';
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    if (type === 'audio/mp4' || type === 'audio/x-m4a' || type === 'audio/m4a' || /\.m4a$/.test(name) || type.indexOf('audio/') === 0 || /\.(mp3|wav|ogg|m4a|aac|mpeg)$/.test(name) || type === 'audio/mpeg') {
      this.uploadMediaType = 'audio';
      this.uploadPreviewUrl = '';
    } else if (type.indexOf('video/') === 0 || /\.(mp4|mov|avi|webm|mkv)$/.test(name)) {
      this.uploadMediaType = 'video';
      this.uploadPreviewUrl = URL.createObjectURL(file);
    } else if (type.indexOf('image/') === 0 || /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name)) {
      this.uploadMediaType = 'image';
      this.uploadPreviewUrl = URL.createObjectURL(file);
    } else {
      this.uploadMediaType = 'document';
      this.uploadPreviewUrl = '';
    }
    this.cdr.detectChanges();
    setTimeout(() => {
      if ($("#messages")[0]) {
        $("#messages").stop().animate({ scrollTop: $("#messages")[0].scrollHeight}, 300);
      }
    }, 50);
  }
  clearUploadPending() {
    if (this.uploadPreviewUrl) {
      try { URL.revokeObjectURL(this.uploadPreviewUrl); } catch (e) {}
    }
    this.uploadingMedia = false;
    this.uploadPreviewUrl = '';
    this.uploadFileName = '';
    this.uploadMediaType = '';
  }
  logout(){
    this.loginService.chatLogout();
  } 
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: any) {
    const target = event.target as HTMLElement;
    if (!target || !target.closest) {
      return;
    }
    if (!target.closest('.chat-attach-wrap')) {
      this.showAttachMenu = false;
    }
  }

  /** Open chat message URLs in a new tab (native navigation — required for mobile) */
  openChatMessageLink(event: any) {
    let el: any = event && event.target ? event.target : null;
    if (!el) { return; }
    if (el.nodeType === 3) {
      el = el.parentElement;
    }
    if (!el || !el.closest) { return; }

    const messagesRoot = el.closest('#messages');
    if (!messagesRoot) { return; }

    const linkEl = el.closest('a.chat-msg-link') as HTMLAnchorElement;
    if (!linkEl || !linkEl.closest('.chat-body, .chat-caption')) {
      return;
    }

    let href = (linkEl.getAttribute('data-url') || '').trim();
    if (!href) {
      href = (linkEl.getAttribute('href') || '').trim();
    }
    if (href.indexOf('unsafe:') === 0) {
      href = href.substring(7);
    }
    if (!href || href === '#' || href.indexOf('javascript:') === 0) {
      const text = (linkEl.textContent || '').trim();
      if (/^(https?:\/\/|www\.)/i.test(text)) {
        href = /^https?:\/\//i.test(text) ? text : 'https://' + text;
      }
    }
    if (!href) { return; }

    linkEl.setAttribute('href', href);
    linkEl.setAttribute('target', '_blank');
    linkEl.setAttribute('rel', 'noopener noreferrer');

    // Do NOT preventDefault — mobile browsers need native <a target="_blank"> navigation
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  }

  chatimageclick(event?: any){
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showAttachMenu = !this.showAttachMenu;
  }
  pickAttach(type: string, event?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showAttachMenu = false;
    const idMap: any = {
      gallery: 'chat-attach-gallery',
      audio: 'chat-attach-audio',
      document: 'chat-attach-document',
      camera: 'chat-attach-camera'
    };
    const el = document.getElementById(idMap[type]) as HTMLInputElement;
    if (el) {
      el.value = '';
      el.click();
    }
  }
   sendrequest()
  {
    this.sendreqestmodel.requeststatus=1;
    //this.Newgroupmodel.userselectedItems.push({'Id':this.Newgroupmodel.currentUserID,'username':this.Newgroupmodel.currentUser});
    this.CommonService.insertdata(AppSettings.sendrequestforgroup,this.sendreqestmodel)
    .subscribe(package_det =>{     
      // this.generateMessageArea(this.Newgroupmodel.g_id);
      //   this.getgrouplists();
        swal('','Request sent successfully','success');  
        
    });
  }
  findmarketer()
  {
    
     this.CommonService.insertdata(AppSettings.findmarketers,this.sendreqestmodel)
    .subscribe(det =>{      
        if(det.status=='error')
        {
          this.group_det=[];

          swal('','Marketer doesnot exists','error'); 
        }
        else
          { 
            this.sendreqestmodel.Isloading= true;
            this.group_det=det.result;
            this.sendreqestmodel.selectedmarketeritems=det;
          }
    });
  }

  msgdeletefun(id:any){
    this.CommonService.insertdata(AppSettings.chatmsgdelete,{'id':id})
    .subscribe(package_det =>{  
      this.generateMessageArea(this.Newgroupmodel.g_id, true, 'incremental');
    });
  }

  msgeditfun(id:any){
    // alert(id);
    this.cancelMsgReply();
    this.CommonService.insertdata(AppSettings.chatmsgedit,{'id':id})
    .subscribe(response =>{    
      this.Newgroupmodel.msgid=response.msg[0].id;
      this.Newgroupmodel.msgupdate=response.msg[0].message;
      this.Newgroupmodel.groupmsgtxt=response.msg[0].message;
      this.editingMsg = true;
      setTimeout(() => {
        const el = document.getElementById('groupmsgtxt') as HTMLTextAreaElement;
        if (el) {
          el.focus();
          el.setSelectionRange(el.value.length, el.value.length);
          this.autoGrowCompose({ target: el });
        }
      }, 50);
    });
  }
  cancelMsgEdit(){
    this.editingMsg = false;
    this.Newgroupmodel.msgid = null;
    this.Newgroupmodel.msgupdate = '';
    this.Newgroupmodel.groupmsgtxt = '';
    this.imageuploadmsg = 0;
    const fileEl = document.getElementById('chatimage') as HTMLInputElement;
    if (fileEl) { fileEl.value = ''; }
    this.resetComposeHeight();
  }
  msgupdatefun(){
    const hasText = this.Newgroupmodel.groupmsgtxt != '' && this.Newgroupmodel.groupmsgtxt != undefined;
    const hasNewFile = this.imageuploadmsg == 1 && this.Newgroupmodel.groupimagename;
    if (!hasText && !hasNewFile) {
      swal('','message is required','error');
      return;
    }
    const payload: any = {
      id: this.Newgroupmodel.msgid,
      msgupdate: hasText ? this.Newgroupmodel.groupmsgtxt : ''
    };
    if (hasNewFile) {
      payload.chatimage = this.Newgroupmodel.groupimagename;
    }
    this.CommonService.insertdata(AppSettings.chatmsgupdate, payload)
    .subscribe(package_det =>{     
      this.clearUploadPending();
      this.cancelMsgEdit();
      this.generateMessageArea(this.Newgroupmodel.g_id, true, 'incremental');
    }, () => {
      this.clearUploadPending();
    });
  }

  replymsgeditfun(data:any){
    this.cancelMsgEdit();
    this.replyingMsg = true;
    this.Newgroupmodel.replymsgid = data.id;
    this.replyUserName = data.user_name || '';
    if (data.message) {
      this.replyPreview = data.message;
    } else if (data.chatimage) {
      this.replyPreview = this.getChatFileName(data.chatimage);
    } else {
      this.replyPreview = '';
    }
    this.Newgroupmodel.groupmsgtxt = '';
    this.Newgroupmodel.replymsgupdate = '';
    setTimeout(() => {
      const el = document.getElementById('groupmsgtxt') as HTMLTextAreaElement;
      if (el) {
        el.focus();
        this.resetComposeHeight();
      }
    }, 50);
  }

  cancelMsgReply(){
    this.replyingMsg = false;
    this.Newgroupmodel.replymsgid = null;
    this.Newgroupmodel.replymsgupdate = '';
    this.replyPreview = '';
    this.replyUserName = '';
    this.imageuploadmsg = 0;
    const fileEl = document.getElementById('chatimage') as HTMLInputElement;
    if (fileEl) { fileEl.value = ''; }
    this.resetComposeHeight();
  }

  replymsgupdatefun(){
    const hasText = this.Newgroupmodel.groupmsgtxt != '' && this.Newgroupmodel.groupmsgtxt != undefined;
    const hasNewFile = this.imageuploadmsg == 1 && this.Newgroupmodel.groupimagename;
    if (!hasText && !hasNewFile) {
      swal('','message is required','error');
      return;
    }
    const payload: any = {
      g_id: this.Newgroupmodel.g_id,
      currentUserID: this.Newgroupmodel.currentUserID,
      currentUser: this.Newgroupmodel.currentUser,
      replymsgid: this.Newgroupmodel.replymsgid,
      replymsgupdate: hasText ? this.Newgroupmodel.groupmsgtxt : '',
      chatimage: hasNewFile ? this.Newgroupmodel.groupimagename : ''
    };
    this.CommonService.insertdata(AppSettings.chatmsgreply, payload)
    .subscribe(package_det =>{
      if (package_det && package_det.status === 'error') {
        this.clearUploadPending();
        swal('', package_det.message || 'failed to send reply', 'error');
        return;
      }
      this.clearUploadPending();
      this.cancelMsgReply();
      this.Newgroupmodel.groupmsgtxt = '';
      this.imageuploadmsg = 0;
      this.resetComposeHeight();
      $('.message-area').addClass('d-sm-flex');
      this.generateMessageArea(this.Newgroupmodel.g_id, true, 'incremental');
      setTimeout(() => {
        if ($("#messages")[0]) {
          $("#messages").stop().animate({ scrollTop: $("#messages")[0].scrollHeight}, 1000);
        }
      }, 100);
    }, () => {
      this.clearUploadPending();
    });
  }

  findMsgById(id: any): any {
    if (!id || !this.group_msg_model) {
      return null;
    }
    for (const dateKey of Object.keys(this.group_msg_model)) {
      const list = this.group_msg_model[dateKey] || [];
      for (const msg of list) {
        if (String(msg.id) === String(id)) {
          return msg;
        }
      }
    }
    return null;
  }

  scrollToReplyMsg(replyid: any, event?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!replyid || replyid == 0 || replyid === '0') {
      return;
    }
    const el = document.getElementById('chat-msg-' + replyid);
    if (!el) {
      swal('', 'Original message not found', 'info');
      return;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.highlightedReplyMsgId = replyid;
    if (this.replyHighlightTimer) {
      clearTimeout(this.replyHighlightTimer);
    }
    this.replyHighlightTimer = setTimeout(() => {
      if (String(this.highlightedReplyMsgId) === String(replyid)) {
        this.highlightedReplyMsgId = null;
      }
      this.replyHighlightTimer = null;
    }, 1600);
  }

  getReplyQuote(data: any): any {
    if (!data || !data.replyid || data.replyid == 0 || data.replyid === '0') {
      return null;
    }
    if (data.reply_user_name || data.reply_message) {
      return {
        user_name: data.reply_user_name || '',
        text: data.reply_message || ''
      };
    }
    const parent = this.findMsgById(data.replyid);
    if (!parent) {
      return { user_name: '', text: 'Original message' };
    }
    let text = parent.message || '';
    if (!text && parent.chatimage) {
      text = this.getChatFileName(parent.chatimage);
    }
    return { user_name: parent.user_name || '', text: text };
  }

  videomyModalfun(val:any,type:any){
    this.Newgroupmodel.videopopupval = val;
    this.Newgroupmodel.video_type = type;
    
  }

  private getMp3Element(id: any): HTMLAudioElement {
    return document.getElementById('chat-mp3-' + id) as HTMLAudioElement;
  }

  toggleMp3Player(id: any, filename: string) {
    const audio = this.getMp3Element(id);
    if (!audio) {
      return;
    }

    if (String(this.playingMp3Id) === String(id) && !audio.paused) {
      audio.pause();
      this.playingMp3Id = null;
      this.cdr.detectChanges();
      return;
    }

    if (this.playingMp3Id != null && String(this.playingMp3Id) !== String(id)) {
      const prev = this.getMp3Element(this.playingMp3Id);
      if (prev) {
        prev.pause();
      }
    }

    this.playingMp3Id = id;
    audio.muted = false;
    audio.volume = 1;

    if (this.playingMp4Id != null) {
      const video = this.getMp4Element(this.playingMp4Id);
      if (video) {
        video.pause();
      }
      this.playingMp4Id = null;
    }

    const playPromise = audio.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => {
        this.cdr.detectChanges();
      }).catch(() => {
        audio.load();
        const retry = audio.play();
        if (retry && typeof retry.then === 'function') {
          retry.then(() => this.cdr.detectChanges()).catch(() => {
            this.playingMp3Id = null;
            this.cdr.detectChanges();
          });
        }
      });
    }
    this.cdr.detectChanges();
  }

  onMp3TimeUpdate(id: any, event: any) {
    if (String(this.playingMp3Id) !== String(id)) { return; }
    const audio = event.target as HTMLAudioElement;
    const duration = audio.duration || 0;
    this.mp3Current[id] = audio.currentTime;
    this.mp3Duration[id] = duration;
    this.mp3Progress[id] = duration ? (audio.currentTime / duration) * 100 : 0;
    this.cdr.detectChanges();
  }

  onMp3Meta(id: any, event: any) {
    const audio = event.target as HTMLAudioElement;
    this.mp3Duration[id] = audio.duration || 0;
    this.cdr.detectChanges();
  }

  onMp3Ended(id: any) {
    this.playingMp3Id = null;
    this.mp3Progress[id] = 0;
    this.mp3Current[id] = 0;
    this.cdr.detectChanges();
  }

  seekMp3Player(event: any, id: any, filename: string) {
    const audio = this.getMp3Element(id);
    if (!audio) {
      return;
    }
    const duration = audio.duration || this.mp3Duration[id];
    if (!duration) {
      this.toggleMp3Player(id, filename);
      return;
    }
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    const pct = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    audio.currentTime = pct * duration;
    this.mp3Current[id] = audio.currentTime;
    this.mp3Progress[id] = pct * 100;
    if (String(this.playingMp3Id) !== String(id) || audio.paused) {
      this.playingMp3Id = id;
      audio.play().catch(() => {
        this.playingMp3Id = null;
      });
    }
    this.cdr.detectChanges();
  }

  downloadMp3(event: any, filename: string) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!filename) {
      return;
    }
    const url = AppSettings.downloadchatfile + '?file=' + encodeURIComponent(filename) + '&download=1';
    const saveAs = this.getChatFileName(filename) || String(filename);

    // Cross-origin iframe downloads are blocked by modern browsers.
    // Fetch as blob, then trigger a same-origin object-URL download.
    fetch(url, { method: 'GET', credentials: 'omit' })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Download failed');
        }
        return res.blob();
      })
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = saveAs;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => {
          try { window.URL.revokeObjectURL(blobUrl); } catch (e) {}
        }, 2000);
      })
      .catch(() => {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  }

  formatMp3Time(id: any): string {
    const playing = String(this.playingMp3Id) === String(id);
    const seconds = playing
      ? (this.mp3Current[id] || 0)
      : (this.mp3Duration[id] || this.mp3Current[id] || 0);
    if (!seconds || isNaN(seconds)) {
      return '00:00';
    }
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  isMp3BarPlayed(id: any, index: number): boolean {
    const progress = this.mp3Progress[id] || 0;
    return ((index + 1) / this.mp3WaveBars.length) * 100 <= progress;
  }

  /** Strip leading unix timestamp from stored upload name */
  getChatFileName(filename: any): string {
    if (!filename) {
      return '';
    }
    const name = String(filename);
    return /^\d{10}/.test(name) ? name.slice(10) : name;
  }

  isChatAudioFile(filename: any): boolean {
    const name = String(filename || '').toLowerCase();
    return name.slice(-4) === '.mp3' || name.slice(-4) === '.m4a';
  }

  /** Grow compose textarea: start 1 line, enlarge up to 4 lines */
  autoGrowCompose(event?: any) {
    const el = (event && event.target)
      ? event.target as HTMLTextAreaElement
      : document.getElementById('groupmsgtxt') as HTMLTextAreaElement;
    if (!el) { return; }
    const minH = 42;
    const maxH = 100;
    el.style.height = 'auto';
    const next = Math.min(Math.max(el.scrollHeight, minH), maxH);
    el.style.height = next + 'px';
    el.style.overflowY = el.scrollHeight > maxH ? 'auto' : 'hidden';
  }

  resetComposeHeight() {
    setTimeout(() => {
      const el = document.getElementById('groupmsgtxt') as HTMLTextAreaElement;
      if (!el) { return; }
      el.style.height = '42px';
      el.style.overflowY = 'hidden';
    }, 0);
  }

  /** Auto RTL for Arabic / Persian (and related) text */
  getTextDir(text: any): string {
    if (text == null || text === '') {
      return 'auto';
    }
    const value = String(text);
    if (/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(value)) {
      return 'rtl';
    }
    return 'ltr';
  }

  /**
   * Split message text into plain text + link parts for template rendering.
   * Real <a> tags (not innerHTML) so clicks open reliably.
   */
  getMessageLinkParts(text: any): Array<{ isLink: boolean; text: string; href?: string }> {
    if (text == null || text === '') {
      return [];
    }
    const raw = String(text);
    const urlRegex = /((?:https?:\/\/|www\.)[^\s<]+|(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:com|org|net|edu|gov|io|co|in|uk|us|info|biz|app|dev|ai|me|tv)(?:\/[^\s<]*)?)/gi;
    const parts: Array<{ isLink: boolean; text: string; href?: string }> = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    urlRegex.lastIndex = 0;
    while ((match = urlRegex.exec(raw)) !== null) {
      if (match.index > lastIndex) {
        parts.push({ isLink: false, text: raw.slice(lastIndex, match.index) });
      }
      let url = match[0];
      let trailing = '';
      while (/[.,;:!?)]$/.test(url)) {
        trailing = url.slice(-1) + trailing;
        url = url.slice(0, -1);
      }
      if (!url || (url.indexOf('@') !== -1 && !/^https?:\/\//i.test(url))) {
        parts.push({ isLink: false, text: match[0] });
      } else {
        const href = /^https?:\/\//i.test(url) ? url : 'https://' + url;
        parts.push({ isLink: true, text: url, href: href });
        if (trailing) {
          parts.push({ isLink: false, text: trailing });
        }
      }
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < raw.length) {
      parts.push({ isLink: false, text: raw.slice(lastIndex) });
    }
    if (!parts.length) {
      parts.push({ isLink: false, text: raw });
    }
    return parts;
  }

  /** Bypass Angular URL sanitizer so http(s) chat links keep a real href */
  trustChatUrl(url: string): any {
    if (!url) { return ''; }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  linkifyMessage(text: any): any {
    const parts = this.getMessageLinkParts(text);
    let html = '';
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (part.isLink && part.href) {
        html += '<a class="chat-msg-link" href="' + this.escapeHtml(part.href)
          + '" target="_blank" rel="noopener noreferrer">' + this.escapeHtml(part.text) + '</a>';
      } else {
        html += this.escapeHtml(part.text || '');
      }
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private escapeHtml(value: string): string {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  onChatLinkClick(event: any) {
    this.openChatMessageLink(event);
  }

  private getMp4Element(id: any): HTMLVideoElement {
    return document.getElementById('chat-mp4-' + id) as HTMLVideoElement;
  }

  toggleMp4Player(id: any) {
    const video = this.getMp4Element(id);
    if (!video) {
      return;
    }

    if (String(this.playingMp4Id) === String(id) && !video.paused) {
      video.pause();
      this.playingMp4Id = null;
      this.cdr.detectChanges();
      return;
    }

    if (this.playingMp4Id != null && String(this.playingMp4Id) !== String(id)) {
      const prev = this.getMp4Element(this.playingMp4Id);
      if (prev) {
        prev.pause();
      }
    }

    if (this.playingMp3Id != null) {
      const audio = this.getMp3Element(this.playingMp3Id);
      if (audio) {
        audio.pause();
      }
      this.playingMp3Id = null;
    }

    this.playingMp4Id = id;
    video.muted = false;
    video.volume = 1;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => {
        this.cdr.detectChanges();
      }).catch(() => {
        video.load();
        const retry = video.play();
        if (retry && typeof retry.then === 'function') {
          retry.then(() => this.cdr.detectChanges()).catch(() => {
            this.playingMp4Id = null;
            this.cdr.detectChanges();
          });
        }
      });
    }
    this.cdr.detectChanges();
  }

  onMp4Ended(id: any) {
    this.playingMp4Id = null;
    this.mp4Current[id] = 0;
    this.cdr.detectChanges();
  }

  onMp4TimeUpdate(id: any, event: any) {
    const video = event.target as HTMLVideoElement;
    if (!video) { return; }
    this.mp4Current[id] = video.currentTime || 0;
    if (video.duration && !isNaN(video.duration)) {
      this.mp4Duration[id] = video.duration;
    }
    this.cdr.detectChanges();
  }

  onMp4Meta(id: any, event: any) {
    const video = event.target as HTMLVideoElement;
    if (!video) { return; }
    this.mp4Duration[id] = video.duration || 0;
    this.cdr.detectChanges();
  }

  formatMp4Time(id: any): string {
    const cur = this.mp4Current[id] || 0;
    const dur = this.mp4Duration[id] || 0;
    const fmt = (seconds: number) => {
      if (!seconds || isNaN(seconds)) {
        return '00:00';
      }
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    };
    if (this.isMp4Playing(id)) {
      return fmt(cur) + ' / ' + fmt(dur);
    }
    return fmt(dur);
  }

  isMp4Playing(id: any): boolean {
    return String(this.playingMp4Id) === String(id);
  }

  toggleMp4Fullscreen(event: any, id: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const frame: any = document.getElementById('chat-mp4-frame-' + id);
    const video: any = this.getMp4Element(id);
    const doc: any = document;
    const isFull = !!(doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement);

    if (!isFull) {
      if (frame) {
        if (frame.requestFullscreen) {
          frame.requestFullscreen();
        } else if (frame.webkitRequestFullscreen) {
          frame.webkitRequestFullscreen();
        } else if (frame.mozRequestFullScreen) {
          frame.mozRequestFullScreen();
        } else if (frame.msRequestFullscreen) {
          frame.msRequestFullscreen();
        } else if (video && video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      } else if (video && video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
    } else {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
    }
  }

  openCaptionModal(id: any, existingMessage: any = '') {
    if (this.editingMsg) {
      this.cancelMsgEdit();
    }
    if (this.replyingMsg) {
      this.cancelMsgReply();
    }
    this.captionMsgId = id;
    this.Newgroupmodel.addcaption = existingMessage ? existingMessage : '';
    setTimeout(() => {
      ($('#addcaptionModal') as any).modal('show');
    }, 0);
  }

  addcaptionfun() {
    const id = this.captionMsgId;
    if (id == null || id === '' || id === undefined) {
      swal('', 'Unable to update caption', 'error');
      return;
    }
    const caption = this.Newgroupmodel.addcaption != null ? String(this.Newgroupmodel.addcaption) : '';
    this.CommonService.insertdata(AppSettings.chatmsgupdate, {
      id: id,
      msgupdate: caption
    }).subscribe(() => {
      this.Newgroupmodel.addcaption = '';
      this.captionMsgId = null;
      ($('#addcaptionModal') as any).modal('hide');
      this.generateMessageArea(this.Newgroupmodel.g_id, false, 'incremental');
    });
  }

  
  otheruseroverviewModal(id:any){
    this.CommonService.insertdata(AppSettings.chatwebsiteflag,{'userid':id,'usertype':2}).subscribe(det =>{
      if(det.result){
        this.Newgroupmodel.otherprofilewebsitelists = det.result;
        this.Newgroupmodel.otherusername = det.username;
        this.Newgroupmodel.websitelock = det.websitelock;
        this.Newgroupmodel.otherpimage = det.pimage;
        
        
      }
  });
  }

  getwebsitelist(){
   
    this.CommonService.insertdata(AppSettings.chatwebsiteflag,{'userid':this.Newgroupmodel.currentUserID,'usertype':2}).subscribe(det =>{
      if(det.result){
        this.Newgroupmodel.profilewebsitelists = det.result;
        this.Newgroupmodel.username = det.username;
        this.Newgroupmodel.aliasname = det.username;
        // this.Newgroupmodel.websitelock = det.websitelock;
        this.Newgroupmodel.otherpimage = det.pimage;
        
      }
  });
    
  }
  
}
